(function ($) {
  window.site = window.site || {};
  site.googleMap = {
    init: function (container) {
      var self = this;
      self.container = $(container);
      if (self.container.length > 0) {
        self._drawMap(container);
      }
    },

    _drawMap: function (container) {
      var self = this;
      var mapElement = self.container.find(".c-map__map")[0];
      var map = new google.maps.Map(mapElement, {
        zoom: 14,
        center: new google.maps.LatLng(
          $(mapElement).attr("data-lat"),
          $(mapElement).attr("data-lng")
        ),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        draggable: true,
        scaleControl: false,
        navigationControl: false,
        streetViewControl: false,
        zoomControl: true,
        scrollwheel: false,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
      });

      self.map = map;
      self._createMarkers();

      var assetsUrl = $("#assetsUrl").attr("content") + "images/";
      new MarkerClusterer(self.map, self.markers, {
        styles: [
          { width: 60, height: 60, url: assetsUrl + "vhg-google-pin-vic.svg" },
          { width: 60, height: 60, url: assetsUrl + "vhg-google-pin-qld.svg" },
          { width: 60, height: 60, url: assetsUrl + "vhg-google-pin-sa.svg" },
          { width: 60, height: 60, url: assetsUrl + "vhg-google-pin-nsw.svg" },
          { width: 60, height: 60, url: assetsUrl + "vhg-google-pin-act.svg" },
        ],
        gridSize: 6,
        calculator: function (markers, numStyles) {
          var index = 1;
          switch (markers[0].state) {
            case "qld":
              index = 2;
              break;
            case "sa":
              index = 3;
              break;
            case "nsw":
              index = 4;
              break;
            default:
              index = 1;
          }

          return {
            text: markers.length,
            index: index,
          };
        },
      });
    },

    _createMarkers: function () {
      var self = this;
      var markers = [];

      self.container.find(".c-map__marker").each(function (index) {
        var markerElem = $(this);
        var lat = $(this).attr("data-lat");
        var lng = $(this).attr("data-lng");
        var pin = $(this).attr("data-pin");
        var state = $(this).attr("data-state");
        var position = new google.maps.LatLng(lat, lng);

        var markerData = {
          position: position,
          map: self.map,
          icon: { url: pin, scaledSize: new google.maps.Size(60, 60) },
          state: state,
        };

        var marker = new google.maps.Marker(markerData);
        var infowindow = new google.maps.InfoWindow({
          content: $(markerElem).find(".c-location-information").html(),
        });

        marker.addListener("click", () => {
          infowindow.open(self.map, marker);
        });

        markers.push(marker);
      });

      self.markers = markers;

      if (self.markers.length > 1) {
        self._centerMap();
      }
    },

    _centerMap: function () {
      var self = this;
      var bounds = new google.maps.LatLngBounds();

      $.each(self.markers, function (index, marker) {
        var latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );
        bounds.extend(latlng);
      });

      self.map.fitBounds(bounds);
    },
  };

  $(() => {
    $("body")
      .find(".c-map")
      .each(function () {
        site.googleMap.init($(this));
      });
  });
})(jQuery);
